// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageUsers_overlayWrapper__DCHVW","viewBox":"ManageUsers_viewBox__274lN","tablestyle":"ManageUsers_tablestyle__Pd3Ra"};